<div class="comments">
  @if (isAuditView()) {
    <!-- Masked restricted item: content hidden, no composer, no fetch. -->
    <div class="comments-empty" [dataSelector]="'cxp-crl-comments-restricted'">
      <aiwyn-icon name="lock" class="comments-empty-icon" [height]="24" [width]="24" />
      <p class="comments-empty-text">This item is restricted.</p>
      <p class="comments-empty-hint">You can see it has activity, but its comments are hidden.</p>
    </div>
  } @else {
  <!-- Always-present "Add a comment" composer. -->
  <div class="composer">
    <app-avatar class="composer-avatar" [avatarInput]="currentUserAvatar" [domain]="'contact'" />
    <div class="composer-field">
      <textarea
        class="composer-input"
        rows="1"
        placeholder="Add a comment"
        [formControl]="newCommentControl"
        [dataSelector]="'cxp-crl-comments-new-input'"
      ></textarea>
      @if (newCommentControl.value.trim()) {
        <div class="composer-actions">
          <button
            andButton
            color="ghost-secondary"
            size="small"
            [dataSelector]="'cxp-crl-comments-new-cancel'"
            (click)="newCommentControl.reset()"
          >
            Cancel
          </button>
          <button
            andButton
            color="primary"
            size="small"
            [isLoading]="isPosting()"
            [disabled]="isPosting()"
            [dataSelector]="'cxp-crl-comments-new-submit'"
            (click)="onAddComment()"
          >
            Comment
          </button>
        </div>
      }
    </div>
  </div>

  @if (hasComments()) {
    <ul class="comment-list">
      @for (comment of comments(); track comment.id) {
        <li class="comment" [cxpCrlCommentDwell]="comment.id" (dwelled)="onCommentDwelled($event)">
          <app-avatar class="comment-avatar" [avatarInput]="avatarFor(comment.author)" [domain]="comment.author.isStaff ? 'staff' : 'contact'" />
          <div class="comment-main">
            <div class="comment-meta">
              <span class="comment-author">{{ comment.author.firstName }} {{ comment.author.lastName }}</span>
              <span class="comment-time">{{ comment.timestamp | cxpRelativeTime }}</span>
              @if (unreadCommentIds().has(comment.id)) {
                <span class="comment-unread-dot" aria-label="Unread comment" [dataSelector]="'cxp-crl-comment-unread'"></span>
              }
            </div>
            <p class="comment-text">{{ comment.text }}</p>

            <button
              type="button"
              class="comment-reply-trigger"
              [dataSelector]="'cxp-crl-comments-reply-trigger'"
              (click)="onStartReply(comment.id)"
            >
              Reply
            </button>

            @if (comment.replies?.length) {
              <ul class="reply-list">
                @for (reply of comment.replies; track reply.id) {
                  <li class="reply" [cxpCrlCommentDwell]="reply.id" (dwelled)="onCommentDwelled($event)">
                    <app-avatar class="reply-avatar" [avatarInput]="avatarFor(reply.author)" [domain]="reply.author.isStaff ? 'staff' : 'contact'" />
                    <div class="comment-main">
                      <div class="comment-meta">
                        <span class="comment-author">{{ reply.author.firstName }} {{ reply.author.lastName }}</span>
                        <span class="comment-time">{{ reply.timestamp | cxpRelativeTime }}</span>
                        @if (unreadCommentIds().has(reply.id)) {
                          <span class="comment-unread-dot" aria-label="Unread comment" [dataSelector]="'cxp-crl-comment-unread'"></span>
                        }
                      </div>
                      <p class="comment-text">{{ reply.text }}</p>
                    </div>
                  </li>
                }
              </ul>
            }

            @if (replyingToId() === comment.id) {
              <div class="reply-composer">
                <textarea
                  class="composer-input"
                  rows="1"
                  placeholder="Add a reply"
                  [formControl]="replyControl"
                  [dataSelector]="'cxp-crl-comments-reply-input'"
                ></textarea>
                <div class="composer-actions">
                  <button
                    andButton
                    color="ghost-secondary"
                    size="small"
                    [dataSelector]="'cxp-crl-comments-reply-cancel'"
                    (click)="onCancelReply()"
                  >
                    Cancel
                  </button>
                  <button
                    andButton
                    color="primary"
                    size="small"
                    [isLoading]="isPosting()"
                    [disabled]="isPosting() || !replyControl.value.trim()"
                    [dataSelector]="'cxp-crl-comments-reply-submit'"
                    (click)="onSubmitReply(comment.id)"
                  >
                    Comment
                  </button>
                </div>
              </div>
            }
          </div>
        </li>
      }
    </ul>
  } @else if (isLoading()) {
    <p class="comments-loading">Loading comments…</p>
  } @else {
    <div class="comments-empty">
      <aiwyn-icon name="chat-circle" class="comments-empty-icon" [height]="24" [width]="24" />
      <p class="comments-empty-text">No comments yet</p>
      <p class="comments-empty-hint">Be the first to leave a comment.</p>
    </div>
  }
  }
</div>
